import { Complaint, TransactionStatusId } from "@eres/rvsapi/entities";
import React, { Component } from "react";
import { LocaleUtil } from "@eres/core";
import { DataTableLang } from "@my-dld/utils/DataTableUtils";
import ListDataView from "../DataView/ListDataView";
import Strings from "@my-dld/assets/strings";
import {
	getComplaintAuthority,
	getComplaintDate,
	getComplaintLicense,
	getComplaintStatus,
	getComplaintTransactionNo
} from "@my-dld/screens/MyDLD/MyRequest/MyComplaints";

export interface MyComplaintsProps {
	isAnyClosed?: boolean;
	items: Complaint[];
	onDetails: ( req: Complaint ) => void;
}

class MyComplaintsListView extends Component<MyComplaintsProps> {
	componentDidMount(): void {
		this.configDataTable();
	}

	render() {
		const { isAnyClosed, items } = this.props;
		return <ListDataView
			items={ items }
			renderListHeader={ () => {
				return <RenderHeader isAnyClosed={ isAnyClosed }/>;
			} }
			renderListItem={ ( item: Complaint ) => {
				return <RenderListItem
					key={ "" + item.TransactionId }
					item={ item }
					isAnyClosed={ isAnyClosed }/>;
			} }/>;
	}

	private configDataTable = () => {
		try {
			window.$( "#ListView" ).DataTable( {
				language: LocaleUtil.Select( DataTableLang ),
				responsive: false,
				lengthChange: false,
				scrollX: true
			} );
			const onDetails = this.props.onDetails;
			window.$( "#ListView" ).on( "click", "a", function () {
				// @ts-ignore
				let item = JSON.parse( this.getAttribute( "data-item" ) );
				if ( item )
					onDetails( item );
				return false;
			} );
		} catch ( e ) {
			console.warn( "Data table unavailable", e );
		}
	};
}

function RenderHeader( props: { isAnyClosed?: boolean } ) {
	const { isAnyClosed } = props;
	return <tr>
		<th>{ Strings.transaction_number }</th>
		<th>{ Strings.status }</th>
		<th>{ Strings.submission_date }</th>
		<th>{ Strings.license_number }</th>
		<th>{ Strings.company_name }</th>
		{ isAnyClosed && <th>{ " " }</th> }
	</tr>;
}

function RenderListItem( props: { item: Complaint, isAnyClosed?: boolean } ) {
	const { item, isAnyClosed } = props;
	const isClosed = item.TransactionStatusId === TransactionStatusId.Closed;
	return <tr>
		<td data-label={ Strings.transaction_number }>{ getComplaintTransactionNo( item ) }</td>
		<td data-label={ Strings.status }>{ getComplaintStatus( item ) }</td>
		<td data-label={ Strings.submission_date }>{ getComplaintDate( item ) }</td>
		<td data-label={ Strings.license_number }>{ getComplaintLicense( item ) }</td>
		<td data-label={ Strings.company_name }>{ getComplaintAuthority( item ) }</td>
		{ isAnyClosed && <td>
			{ isClosed && <a
				href="#"
				data-item={ JSON.stringify( item ) }>
				<i className="far fa-arrow-alt-circle-right"/>
			</a> }
		</td> }
	</tr>;
}

export default MyComplaintsListView;
